import { SUBSCRIPTION_TIERS } from '../config/subscriptionPlans';

/**
 * Checks if the given plan ID belongs to a faculty/school scope.
 */
export const isFacultyPlanScope = (planId: string): boolean => {
  if (!planId) return false;
  return planId.includes('school') || planId === 'faculty_member';
};

/**
 * Checks if the given plan ID belongs to an individual scope.
 */
export const isIndividualPlanScope = (planId: string): boolean => {
  if (!planId) return false;
  return planId.includes('individual') && !planId.includes('trial');
};

/**
 * Formats a plan ID into a human-readable display name.
 */
export const getPlanDisplayName = (planId: string): string => {
  if (!planId) return 'No Plan';

  const exactMatches: Record<string, string> = {
    starter: 'Individual (Free Trial)',
    individual_trial: 'Individual (Free Trial)',
    school_trial: 'Faculty (Free Trial)',
    faculty_member: 'Faculty Member'
  };

  if (exactMatches[planId]) return exactMatches[planId];

  // Dynamically resolve from config if possible
  for (const tier of Object.values(SUBSCRIPTION_TIERS)) {
    for (const [scope, cycles] of Object.entries(tier.variants)) {
      for (const [cycle, variant] of Object.entries(cycles)) {
        if (variant.id === planId) {
          const scopeLabel = scope === 'faculty' ? 'Faculty Plan' : 'Individual Plan';
          const cycleLabel = cycle.charAt(0).toUpperCase() + cycle.slice(1);
          // e.g., "Faculty Plan — Monthly (Tier 1)" or just "Faculty Plan — Monthly"
          return tier.id === 'tier1' 
            ? `${scopeLabel} — ${cycleLabel}` 
            : `${scopeLabel} — ${cycleLabel} (${tier.name})`;
        }
      }
    }
  }

  // Fallback for unknown plans
  return planId.replace(/_/g, ' ').toUpperCase();
};

/**
 * Helper to determine if a plan is a trial plan.
 */
export const isTrialPlan = (planId: string): boolean => {
  return planId.includes('trial') || planId === 'individual_trial';
};
